export enum SidebarMenu {
  USER = 'User',
  SIZE = 'Size',
  IMAGE = 'Image',
  ORDER = 'Order',
  SHIPPO_TRACKING = 'ShippoTracking',
  DESIGN = 'Design',
  STATISTIC = 'Statistic',
  API_ACCESS = 'ApiAccess',
  STORE = 'Store',
  INVOICE_INFO = 'InvoiceInfo',
}
